import Vue from 'vue'

// Arep Ui
import ARStyle from 'arep-ui/dist/plugins/ar-style'
import ARNotification from 'arep-ui/dist/plugins/ar-notification'
import ARMediaQuery from 'arep-ui/dist/plugins/ar-media-query'
import ARModal from 'arep-ui/dist/components/ARModal'
import ARIcon from 'arep-ui/dist/components/ARIcon'
import ARText from 'arep-ui/dist/components/ARText'
import ARSimpleButton from 'arep-ui/dist/components/ARSimpleButton'
import ARCheckbox from 'arep-ui/dist/components/ARCheckbox'
import ARLinkButton from 'arep-ui/dist/components/ARLinkButton'
import ARIconButton from 'arep-ui/dist/components/ARIconButton'

Vue.use(ARStyle)
Vue.use(ARNotification)
Vue.use(ARMediaQuery)
Vue.component('ar-modal', ARModal)
Vue.component('ar-icon', ARIcon)
Vue.component('ar-text', ARText)
Vue.component('ar-simple-button', ARSimpleButton)
Vue.component('ar-checkbox', ARCheckbox)
Vue.component('ar-link-button', ARLinkButton)
Vue.component('ar-icon-button', ARIconButton)
